export const API_BASE_URL = import.meta.env.VITE_API_ENDPOINT;
export const API_MM_URL = import.meta.env.VITE_API_MM_ENDPOINT;
export const API_DINE_IN_URL = import.meta.env.VITE_API_DINE_IN_ENDPOINT;
export const API_PAYMENTS_URL = import.meta.env.VITE_API_PAYMENTS_ENDPOINT;
export const API_CUSTOMER_PROFILE_URL = import.meta.env.VITE_API_CUSTOMER_PROFILE_ENDPOINT;
export const API_CUSTOMER_MENU_URL = import.meta.env.VITE_API_CUSTOMER_MENU_URL;
export const API_EVENTS_URL = import.meta.env.VITE_API_EVENTS_URL;
export const API_EVENTS_KEY = import.meta.env.VITE_API_EVENTS_KEY;
export const INITIAL_CDN_PATH = import.meta.env.VITE_INITIAL_CDN_PATH;
